module.exports = __webpack_public_path__ + "static/media/truck.18b6d77d.svg";